<template>
  <div>
    <dialog-email
      :isLoading="isLoading"
      ref="dialogEmail"
      :contentKey="contentKey"
      :contentMap="contentData"
      :data="emailData"
      @on-submit-email="onSubmitEmail"
    >
    </dialog-email>
    <dialog-alert
      ref="dialogAlert"
      :config="configAlert"
    >
    </dialog-alert>
  </div>
</template>

<script>
import { ServiceRFQs } from '@/services/RFQs'
import { ServiceEmailMessages } from '@/services/email-messages'

export default {
  name: 'SendQuoteMultiParts',
  components: {
    'dialog-email': () => import(/* webpackChunkName: 'Dialogs' */ '@/components/Dialogs/DialogEmail/index'),
    'dialog-alert': () => import(/* webpackChunkName: 'Dialogs' */ '@/components/Dialogs/DialogAlert')
  },
  props: {
    rfqID: { required: true },
    partIDs: { required: true, type: Array }
  },
  data () {
    return {
      isLoading: false,
      logoType: 0,
      dataRFQ: {},
      emailData: {},
      contentData: {}
    }
  },
  computed: {
    configConfirm () {
      return {
        title: this.L10n('confirm'),
        text: this.L10n('already-sent-are-you-sure')
      }
    },
    configAlert () {
      return {
        title: this.L10n('general-warning'),
        text: this.L10n('please-select-contact')
      }
    },
    contentKey () {
      return 'quote-multi-parts-email'
    },
    emailSubject () {
      return `Multiple quote from Bel-Air Express`
    }
  },
  methods: {
    show ({ logoType }) {
      this.logoType = logoType
      this.loadData()
        .then(() => {
          if (!this.dataRFQ.customerContactID) {
            return this._showAlert()
          } else {
            return this._showEmail()
          }
        })
    },
    hide () {
      this.logoType = 0
      this.dataRFQ = {}
      this.contentData = {}
      this.isLoading = false

      this._hideEmail()
      this._hideAlert()
    },
    onSubmitEmail (data) {
      this.requestSubmitEmail(data)
    },
    async requestSubmitEmail (emailData) {
      this.isLoading = true

      try {
        await ServiceEmailMessages.sendQuoteMultiParts({
          id: this.dataRFQ.id,
          logoKey: this.logoType,
          partIDs: this.partIDs,
          translate: this.L10n,
          ...emailData
        })
        this.requestSuccessHandler()
        this.$emit('onSuccess')
      } catch (e) {
        this.requestErrorHandler(e)
      } finally {
        this.hide()
      }
    },
    loadData () {
      this.isLoading = true
      return Promise
        .all([
          this.loadDataRFQ()
        ])
        .then(() => {
          this.contentData = this._createContentData({ ...this.dataRFQ })
        })
        .catch((err) => {
          this.requestErrorHandler(err)
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    loadDataRFQ () {
      return ServiceRFQs.getDynamic(this.rfqID, {
        select: [
          'id', 'customerCompany.name as customerCompanyName', 'customerContact.name as customerContactName',
          'customerContactID', 'customerContact.email as email'
        ].join(',')
      })
        .then(({ data }) => {
          this.dataRFQ = data
        })
    },
    _showEmail () {
      this._createEmailData()
      this.$refs.dialogEmail.show()
    },
    _showAlert () {
      this.$notify
        .warning({
          title: this.L10n('general-warning'),
          message: this.L10n('please-select-contact'),
          position: 'bottom-right'
        })
      this.$refs.dialogAlert.show()
    },
    _hideEmail () {
      this.emailData = {}
      this.$refs.dialogEmail.hide()
    },
    _hideAlert () {
      this.$refs.dialogAlert.hide()
    },
    _createEmailData () {
      let subject = this.emailSubject
      let emailToList = []
      this.dataRFQ.email && emailToList.push(this.dataRFQ.email)
      this.emailData = {
        subject,
        emailToList
      }
    },
    _createContentData (data) {
      const noValue = '--NO VALUE--'
      return {
        'customerContactName': data.customerContactName || noValue,
        'customerCompanyName': data.customerCompanyName || noValue
      }
    }
  }
}
</script>
